import { FC, ReactElement } from 'react'
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels'
import { Route, Routes } from 'react-router'

import { Page } from '@/components'
import { ConnectedMessages } from '@/connectors'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { MessageDetailPage } from '@/pages/MessageDetailPage/MessageDetailPage'

import './MessagesPage.scss'

// Matches the `tablet-landscape-up` breakpoint in src/styles/helpers/_mixins.scss
const SIDE_BY_SIDE_QUERY = '(min-width: 1024px)'

export const MessagesPage: FC = (): ReactElement => {
    const isSideBySide = useMediaQuery(SIDE_BY_SIDE_QUERY)

    const renderContent = (hasDetail: boolean): ReactElement => {
        if (! isSideBySide) {
            return hasDetail ? <MessageDetailPage /> : <ConnectedMessages />
        }

        if (! hasDetail) {
            return <ConnectedMessages />
        }

        return (
            <PanelGroup direction="horizontal" className="messages-page__panels">
                <Panel minSize={25} defaultSize={40}>
                    <ConnectedMessages />
                </Panel>
                <PanelResizeHandle className="messages-page__resize-handle" />
                <Panel minSize={30}>
                    <MessageDetailPage />
                </Panel>
            </PanelGroup>
        )
    }

    return (
        <Page className="messages-page">
            <Routes>
                <Route path=":channelId/*" element={renderContent(true)} />
                <Route path="*" element={renderContent(false)} />
            </Routes>
        </Page>
    )
}
